import {
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import clsx from "clsx";
import { format } from "date-fns";
import { formatUtcToDate } from "../../../shared/formattedDate";
import useToCalendarButtons from "../../../shared/hooks/use-to-calendar-buttons";
import {
  CircleExclamationIcon,
  ScheduleSuccessIcon,
  TipsIcon,
  TrashIcon,
} from "../../../shared/icons";
import { EditPageAndPencilIcon } from "../../../shared/icons/EditPageAndPencilIcon";
import { useStyle } from "./schedule-success.styles";

type Props = {
  isQuickWin?: boolean;
  isSaved?: boolean;
  onEditClick(): void;
  onCancelEventClick: () => void;
  event: {
    location: string;
    start: Date | string;
  };
};

export function ScheduleSuccess({
  isQuickWin,
  event,
  isSaved,
  onEditClick,
  onCancelEventClick,
}: Props) {
  const classes = useStyle();
  const { SelectCalendarProvider } = useToCalendarButtons(event);

  const locationType = ["zoom", "Zoom", "www"].includes(event.location)
    ? "Zoom"
    : "Phone call";

  const formatDate = (date: Date | string) => {
    date = formatUtcToDate(date);
    return format(date, "eee, MMM dd - h:mmaaaa").replace("-", "at");
  };

  return (
    <Grid item container className={classes.scheduleSuccessGridContainer}>
      {!isSaved && !isQuickWin ? (
        <Typography className={classes.successTitle}>
          Next 1:1 Scheduled
        </Typography>
      ) : (
        <>
          <Grid item className={classes.scheduleSuccessGrid}>
            <ScheduleSuccessIcon
              className={clsx({ [classes.bigIcon]: isQuickWin })}
            />
          </Grid>
          <Grid item className={classes.scheduleSuccessGrid}>
            <Typography className={classes.successTitle}>
              1:1 meeting
            </Typography>
            <Typography className={classes.successTitle}>
              scheduled successfully!
            </Typography>
          </Grid>
          <Divider className={classes.divider} />
        </>
      )}
      <Grid item container>
        <Grid item className={classes.scheduleSuccessGrid}>
          <Typography className={classes.locationTitle}>
            {locationType} meeting
          </Typography>
          <Grid item container alignItems="center" justifyContent="center">
            {event?.start && (
              <Typography className={classes.datetimeTitle}>
                {formatDate(event.start)}
              </Typography>
            )}
            <Tooltip
              title="Edit meeting"
              arrow
              placement="left"
              classes={{
                tooltip: classes.tooltip,
                arrow: classes.arrowToolTip,
              }}
            >
              <IconButton
                onClick={onEditClick}
                className={classes.editIconButton}
              >
                <EditPageAndPencilIcon />
              </IconButton>
            </Tooltip>{" "}
            <Tooltip
              title="Cancel meeting"
              arrow
              placement="left"
              classes={{
                tooltip: classes.tooltip,
                arrow: classes.arrowToolTip,
              }}
            >
              <IconButton
                onClick={onCancelEventClick}
                className={classes.editIconButton}
              >
                <TrashIcon />
              </IconButton>
            </Tooltip>
          </Grid>
          {event.location === "Zoom" && (
            <Grid item container className={classes.zoomTipContainer}>
              <div className={classes.zoomTipIcon}>
                <CircleExclamationIcon />
              </div>
              <Typography className={classes.zoomTip}>
                Your Mentor will send you the link of the meeting via email.
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item container>
        <Grid item className={classes.scheduleSuccessGrid}>
          <SelectCalendarProvider itemClassName={classes.addTo} />
        </Grid>
      </Grid>
      <Grid item container className={classes.tips}>
        <Grid item container>
          <TipsIcon />
          <Typography className={classes.tipsTitle}>
            Be prepared for your meeting!
          </Typography>
        </Grid>
        <Typography className={classes.tipsText}>
          Plan an agenda with the questions and topics you&apos;d like to
          discuss. If you&apos;d like to work together on long-term goals, set
          some time to discuss expectations for each other.
        </Typography>
      </Grid>
    </Grid>
  );
}

ScheduleSuccess.defaultProps = {
  isSaved: false,
  isQuickWin: false,
};
